export default __webpack_public_path__ + "static/media/video.f7082546.png";